/**
 * TutorOffersScreen — l'onglet « Offres de cours » de la coquille (onglet `proposals`).
 *
 * Un fil : l'onglet demandé et la feuille (`useTutorOffersUi`), le view-model, les lectures de
 * l'onglet montré (`useTutorOffersData`), les gestes et les réponses (`useTutorOffersState`), la page.
 */
import React from "react"
import { useSelector } from "react-redux"

import { TutorOffersPage } from "../../../../../../design-system/tutor"
import { tutorOffersViewModel } from "../../../../view-models/tutor/Availability/tutorOffersViewModel"
import { type TutorSpaceScreenProps } from "../tutorSpaceRouteTypes"
import { useTutorOffersData } from "./useTutorOffersData"
import { useTutorOffersState, useTutorOffersUi } from "./useTutorOffersState"

const LOAD_ERROR = "Impossible de charger les offres"

export function TutorOffersScreen({ route }: TutorSpaceScreenProps) {
    const [ui, dispatchUi] = useTutorOffersUi()
    const vm = useSelector((state: unknown) => tutorOffersViewModel(state, ui.requestedKind))
    const data = useTutorOffersData(vm.activeKind, vm.offers.length > 0)
    const gestures = useTutorOffersState(vm, ui, dispatchUi, route?.params)

    return (
        <TutorOffersPage
            tabs={vm.tabs}
            activeKind={vm.activeKind}
            offers={vm.offers}
            dispoStale={vm.dispoStale}
            onRefresh={data.refresh}
            refreshing={data.refreshing}
            listLoading={data.listLoading}
            loadingMore={data.loadingMore}
            hasMore={data.hasMore}
            onLoadMore={data.loadMore}
            loadMoreError={data.loadMoreError}
            loading={vm.loading}
            // Sans offre en main, une première page ratée se dit ; avec, la liste reste.
            error={data.firstPageFailed && vm.offers.length === 0 ? LOAD_ERROR : undefined}
            onRetry={data.refresh}
            {...gestures}
            testID="tutor-offers"
        />
    )
}
